import { render } from "./ThousandInput.vue?vue&type=template&id=2a8beffe"
import script from "./ThousandInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ThousandInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UI/inputs/ThousandInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8beffe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8beffe', __exports__)) {
    api.reload('2a8beffe', __exports__)
  }
  
  module.hot.accept("./ThousandInput.vue?vue&type=template&id=2a8beffe", () => {
    api.rerender('2a8beffe', render)
  })

}


export default __exports__